module.exports = __webpack_public_path__ + "static/img/newLoad_top_bg1.756762d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/download/newLoad_top_bg1.png
// module id = KfSI
// module chunks = 3